export const showMessage = 'showMessage';
export const hideMessage = 'hideMessage';
export const SAVE_AUTHORIZATION = 'SAVE_AUTHORIZATION';
export const CLEAR_AUTHORIZATION = 'CLEAR_AUTHORIZATION';
export const SET_GRAPHQL_ERRORS = 'SET_GRAPHQL_ERRORS';
export const SET_NETWORK_ERROR = 'SET_NETWORK_ERROR';
export const SAVE_FILTERS = 'SAVE_FILTERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SAVE_TICKETS_FILTERS = 'SAVE_TICKETS_FILTERS';
export const CLEAR_TICKETS_FILTERS = 'CLEAR_TICKETS_FILTERS';
export const SET_FORMAL_NOTICE = 'SET_FORMAL_NOTICE';
export const CLEAR_FORMAL_NOTICE = 'CLEAR_FORMAL_NOTICE';
export const SET_COURT_APPLICATION = 'SET_COURT_APPLICATION';
export const CLEAR_COURT_APPLICATION = 'CLEAR_COURT_APPLICATION';



// WEBPACK FOOTER //
// ./src/actions/action-types.js